<template>
  <div class="col-12 form-group form-group-sm">
    <label class="label" for="vehiculo">Servicio Técnico</label>
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-around">
          <div class="btn-group btn-group-sm">
            <button
              @click="$bvModal.show('cambiarAvlForm')"
              class="btn btn-primary"
            >
              Cambio de Avl Chip
            </button>
          </div>
          <div class="btn-group btn-group-sm">
            <button
              @click="$bvModal.show('cambiarVehiculoForm')"
              class="btn btn-primary"
            >
              Cambiar vehículo
            </button>
          </div>
          <div class="btn-group btn-group-sm">
            <button
              @click="$bvModal.show('mantenimientoForm')"
              class="btn btn-primary"
            >
              Reparacion/Mantenimiento
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ButtonsServicioTecnico",
};
</script>
